import { object, string } from "superstruct";

import type { PathParamsBase } from "../endpoint/Endpoint.js";
import Endpoint from "../endpoint/Endpoint.js";
import EndpointRouter from "../endpoint/EndpointRouter.js";
import { JoinSessionSchema } from "../models/JoinSession.js";
import { type Projet } from "../models/Projet.js";
import type { User } from "../models/User.js";

export default function buildJoinSessionRouter(
    base: EndpointRouter<PathParamsBase, { user: User; projet: Projet }>,
) {
    const router = base.addRouter(new EndpointRouter());

    const endpoints = {
        createJoinSessionEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath("/join-sessions", object({}))
                .setResultParser(JoinSessionSchema)
                .setBodySchema(object({})),
        ),
        getJoinSessionEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("GET")
                .setPath("/join-sessions/:joinSession", object({ joinSession: string() }))
                .setResultParser(JoinSessionSchema),
        ),
        invalidateJoinSessionEndpoint: router.addEndpoint(
            new Endpoint()
                .setMethod("POST")
                .setPath(
                    "/join-sessions/:joinSession/invalidate",
                    object({ joinSession: string() }),
                )
                .setResultParser(JoinSessionSchema)
                .setBodySchema(object({})),
        ),
    };

    return { router, endpoints };
}
